import Hashids from 'hashids';
import { salt } from '../components/config';
const hashids = new Hashids(salt, 8);

export const encodeId = (id) => {
  if (!id) return console.error('id is required');
  const encode = hashids.encode(id);
  return encode;
};

export const decodeId = (id) => {
  if (!id) return console.error('id is required');
  const decoded = hashids.decode(id);
  return decoded.length > 0 ? decoded[0] : null;
};
